import React from 'react';
import { Link } from 'react-router-dom';
import { useDropdown } from './DropdownContext';

const DropdownMenu = () => {
  const { setOpenDropdown } = useDropdown();

  const handleClick = () => {
    setOpenDropdown(null);
  };

  return (
    <li className="relative group">
      <Link
        to="/education"
        className="dark:hover:text-dark-5 hover:text-buiha-red py-2 px-4 lg:text-2xl text-xl md:flex hidden items-center font-medium"
        onClick={handleClick}
      >
        {/* Header */}
        Education
      </Link>
    </li>
  );
};

export default DropdownMenu;
